export interface Article {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  date: string;
  author: string;
  views: number;
  tags: string[];
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: "独家爆料：某顶流男星被曝深夜私会神秘女子，疑似婚内出轨",
    excerpt: "据知情人士透露，某一线顶流男星近日被拍到深夜与一名神秘女子共进晚餐后同回酒店，全程举止亲密。该男星已结婚多年，此消息一出立即引爆全网热议。",
    content: `<p>据圈内知情人士独家向本平台爆料，某当红一线顶流男星近日在横店拍戏期间，被多次目击深夜与一名神秘女子共进晚餐，两人餐后多次同回某高档酒店，举止亲密远超普通朋友关系。</p><p>据爆料人描述，该男星与神秘女子曾在某高档日料餐厅包间密会长达三小时，期间有服务员进入包间时，两人正在亲密互动。饭后两人一前一后离开餐厅，但最终都回到了同一家酒店。</p><p>令人震惊的是，该男星已与圈内某知名女演员结婚多年，两人一直以\"模范夫妻\"形象示人，育有一子一女。如果此爆料属实，这无疑将是今年娱乐圈最大的丑闻之一。</p><p>有网友扒出该男星近期社交动态，发现其妻子最近一条关于丈夫的动态停留在三个月前，且两人已有近半年未被拍到同框。这更加剧了网友对其婚变的猜测。</p><p>截至目前，该男星工作室尚未对此事做出任何回应。本平台将持续关注此事的最新进展。</p>`,
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20silhouette%20of%20celebrity%20couple%20in%20luxury%20restaurant%20at%20night%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20dim%20warm%20lighting%2C%20cinematic%20composition%2C%20high%20contrast%20shadows%2C%20elegant%20interior%20with%20warm%20amber%20glow&width=800&height=500&seq=article-1-2026&orientation=landscape",
    date: "2026-08-06",
    author: "黑料侦探",
    views: 283000,
    tags: ["顶流男星", "婚内出轨", "深夜约会", "横店"],
    isHot: true,
  },
  {
    id: 2,
    title: "某选秀节目冠军被曝全靠资本运作，真实实力遭导师群嘲",
    excerpt: "近日有内部工作人员爆料，某大型选秀节目的最终冠军人选早在比赛开始前就已内定。该选手背后有强大资本力量，导师们私下对其真实水平评价极低。",
    content: `<p>一档备受关注的全国大型选秀节目近日被内部工作人员爆料存在严重黑幕。据该工作人员透露，节目最终冠军早在海选阶段就已经内定，整个比赛过程实际上是一场精心策划的\"真人秀\"。</p><p>爆料人称，该冠军选手背后有某大型娱乐资本的力量在运作，其经纪公司与节目制作方存在深度利益绑定。节目组为了塑造该选手的\"逆袭\"故事线，不惜恶意剪辑其他选手的表现，甚至在关键投票环节进行数据造假。</p><p>更令人咋舌的是，多位节目导师在私下交流时，对该选手的真实唱功和舞蹈水平给出了极低的评价。一位不愿透露姓名的导师曾在休息室直言：\"这是我这辈子见过最离谱的选秀结果。\"</p><p>该节目此前一直标榜\"公平公正、凭实力说话\"，如今这一爆料无疑是对节目公信力的沉重打击。众多观众在社交媒体上表达了愤怒和失望，要求节目组公开所有投票数据。</p>`,
    category: "zongyi-neimu",
    categoryName: "综艺内幕",
    imageUrl: "https://readdy.ai/api/search-image?query=dramatic%20stage%20with%20spotlight%20on%20empty%20center%2C%20talent%20show%20set%20with%20dark%20atmosphere%2C%20backstage%20conspiracy%20vibe%2C%20theatrical%20lighting%20with%20warm%20and%20cool%20contrast%2C%20moody%20cinematic%20photography&width=800&height=500&seq=article-2-2026&orientation=landscape",
    date: "2026-08-06",
    author: "综艺观察员",
    views: 196000,
    tags: ["选秀节目", "资本运作", "内定冠军", "导师群嘲"],
    isHot: true,
  },
  {
    id: 3,
    title: "当红小花被曝片场耍大牌，迟到三小时还要求全组等她补妆",
    excerpt: "多位剧组工作人员联合爆料某95后当红小花在拍摄现场种种耍大牌行为，包括经常迟到、对工作人员颐指气使、要求专属休息室等，引发全组不满。",
    content: `<p>近日，有多位正在参与某古装剧拍摄的剧组工作人员联合向本平台爆料，称剧组女一号、某95后当红小花在片场耍大牌成性，各种行为令人发指。</p><p>据爆料，该小花几乎每天都会迟到，少则半小时，多则三小时以上。有一次全剧组从早上六点就开始准备，结果她直到上午九点半才姗姗来迟，到场后也不立即开拍，而是要求先补妆一小时，让全组近百号人干等。</p><p>除了迟到成性，该小花对剧组工作人员的态度也极其恶劣。有场务人员透露，她曾因为一杯咖啡的温度不够热而当众把咖啡摔在地上，还辱骂工作人员\"没脑子\"。此外，她还要求剧组为她配备专属的独立休息室和专用卫生间，不允许任何其他人使用。</p><p>业内人士分析，该小花之所以如此嚣张，与其背后强大的经纪公司有关。此前已有多个剧组传出类似投诉，但都被其公司以各种方式压了下来。</p>`,
    category: "yingshi-quan",
    categoryName: "影视圈",
    imageUrl: "https://readdy.ai/api/search-image?query=luxury%20trailer%20on%20film%20set%20with%20makeup%20mirror%20and%20vanity%20lights%2C%20diva%20atmosphere%2C%20film%20production%20set%20in%20background%20blurred%2C%20warm%20glamorous%20lighting%2C%20behind%20the%20scenes%20movie%20set%20photography&width=800&height=500&seq=article-3-2026&orientation=landscape",
    date: "2026-08-05",
    author: "片场观察员",
    views: 175000,
    tags: ["当红小花", "耍大牌", "片场风波", "古装剧"],
    isHot: true,
  },
  {
    id: 4,
    title: "知名歌手被曝新歌抄袭海外小众乐队，扒谱对比触目惊心",
    excerpt: "有音乐人通过专业扒谱对比发现，某知名华语歌手的最新主打歌与一支海外小众乐队三年前的作品高度相似，副歌部分的和弦进行几乎完全一致。",
    content: `<p>一场关于音乐抄袭的争议正在社交平台上持续发酵。一位独立音乐人在微博发布了一段详细的扒谱对比视频，指出某知名华语歌手最新专辑主打歌与一支北欧小众独立乐队三年前发行的单曲存在惊人的相似之处。</p><p>根据该音乐人的分析，两首歌在副歌部分的和弦进行几乎完全一致，旋律线条的重合度高达80%以上。更令人起疑的是，甚至连编曲中的某些标志性音色处理都如出一辙。</p><p>该对比视频发布后迅速引发热议，播放量已突破500万。有网友翻出该歌手此前也有过类似的抄袭争议，只不过当时被其粉丝以\"音乐风格相似很正常\"为由搪塞过去。</p><p>目前，被抄袭的北欧乐队已在社交媒体上关注了此事，并表示\"正在了解情况\"。业内人士分析，如果该乐队决定追究法律责任，这将是近年来华语乐坛涉及国际抄袭纠纷的最大案例之一。</p>`,
    category: "yinle-quan",
    categoryName: "音乐圈",
    imageUrl: "https://readdy.ai/api/search-image?query=musical%20score%20sheets%20side%20by%20side%20comparison%20with%20red%20circles%20highlighting%20similarities%2C%20recording%20studio%20background%20with%20warm%20ambient%20lighting%2C%20professional%20music%20production%20setting%2C%20dramatic%20composition&width=800&height=500&seq=article-4-2026&orientation=landscape",
    date: "2026-08-05",
    author: "乐评人小王",
    views: 142000,
    tags: ["抄袭风波", "华语歌手", "扒谱对比", "北欧乐队"],
    isHot: true,
  },
  {
    id: 5,
    title: "某综艺嘉宾酒后失言曝光节目剧本，导演组紧急删减画面",
    excerpt: "据现场观众爆料，某知名综艺节目录制过程中，一位嘉宾在酒后不慎说出了节目的剧本安排细节，导演组随即叫停录制并紧急进行剪辑处理。",
    content: `<p>一起综艺节目录制事故近日被现场观众曝光。据悉，在某知名综艺节目的最新一期录制中，一位嘉宾在游戏环节饮用了大量酒精饮品后，竟在镜头前直接说出了节目的剧本安排。</p><p>据现场知情人描述，该嘉宾当时明显处于醉酒状态，在与其他嘉宾互动时脱口而出：\"反正按照台本下一轮应该是你赢，我就不跟你争了。\"此言一出，现场气氛瞬间凝固，其他嘉宾和主持人的表情极为尴尬。</p><p>导演组迅速反应，立即叫停了录制。随后工作人员将所有现场观众的电子设备全部收走并进行检查，以确保没有任何视频外泄。录制在中断约40分钟后才重新开始，但该嘉宾的后续镜头被大幅删减。</p><p>此事件再次引发了公众对综艺节目\"真人秀\"真实性的讨论。有观点认为，综艺节目有一定程度的\"剧本引导\"已是公开的秘密，但被当场戳穿的翻车事件仍然令人唏嘘。</p>`,
    category: "zongyi-neimu",
    categoryName: "综艺内幕",
    imageUrl: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20cameras%20and%20lights%2C%20dramatic%20moment%20of%20interruption%2C%20crew%20members%20in%20background%20looking%20concerned%2C%20warm%20studio%20lighting%20with%20tense%20atmosphere%2C%20behind%20the%20scenes%20television%20production&width=800&height=500&seq=article-5-2026&orientation=landscape",
    date: "2026-08-04",
    author: "综艺观察员",
    views: 128000,
    tags: ["综艺剧本", "酒后失言", "录制事故", "真人秀"],
    isHot: false,
  },
  {
    id: 6,
    title: "娱乐圈又一对金童玉女被曝已秘密分手，双方团队联合封口",
    excerpt: "曾经被誉为娱乐圈最般配情侣的一对明星被曝已于三个月前秘密分手。双方团队为防止影响商业代言，联合签署了为期一年的\"封口协议\"。",
    content: `<p>据多位圈内人士证实，娱乐圈那对曾经被粉丝称为\"神仙眷侣\"的明星情侣，实际上已经在三个月前秘密分手。然而出于商业利益考虑，双方至今仍对外保持恋爱关系。</p><p>知情人士透露，两人共同代言的品牌高达十余个，涉及奢侈品、护肤品、饮料等多个领域。一旦公开分手消息，按照合同条款，两人可能面临高达数亿元的违约金赔偿。因此双方经纪团队紧急商议后，决定签署一份为期一年的\"封口协议\"。</p><p>根据协议内容，双方在一年内不得公开承认分手，需要在社交媒体上维持正常互动，在公共场合继续以情侣身份出席活动。一年后待代言合同陆续到期，再择机\"和平分手\"。</p><p>有细心粉丝已经发现端倪：两人最近三个月的互动明显\"营业化\"，合照都是工作场合的摆拍，私下已无任何同框。多位圈内好友也已在社交媒体上取消了对两人的关注。</p>`,
    category: "lianqing-gua",
    categoryName: "恋情瓜",
    imageUrl: "https://readdy.ai/api/search-image?query=celebrity%20couple%20standing%20apart%20on%20red%20carpet%20looking%20in%20opposite%20directions%2C%20paparazzi%20flash%20photography%2C%20tense%20emotional%20distance%2C%20glamorous%20event%20setting%2C%20warm%20golden%20hour%20lighting&width=800&height=500&seq=article-6-2026&orientation=landscape",
    date: "2026-08-04",
    author: "情感观察室",
    views: 210000,
    tags: ["金童玉女", "秘密分手", "封口协议", "商业代言"],
    isHot: true,
  },
  {
    id: 7,
    title: "最新爆料：知名导演被多位女演员联合举报性骚扰",
    excerpt: "三位女演员通过社交媒体联合发声，指控某知名导演在合作期间存在性骚扰行为。该导演曾执导多部票房过亿的影片，在圈内地位极高。",
    content: `<p>一场针对知名导演的性骚扰指控正在娱乐圈掀起轩然大波。三位曾与该导演合作过的女演员近日通过社交媒体平台联合发布声明，详细描述了在合作期间遭受的性骚扰经历。</p><p>三位女演员在联合声明中列举了多项具体指控，包括但不限于：在试镜时提出不当要求、在深夜发送骚扰短信、在剧组聚餐时进行肢体骚扰等。其中一位女演员表示，她曾因为拒绝该导演的\"暗示\"而被删减了原本承诺的戏份。</p><p>该导演在业内地位极高，曾执导多部票房过十亿的商业大片，与多家头部影视公司关系密切。事发后，该导演工作室发布简短声明称\"所有指控均为恶意诽谤，将采取法律手段维护权益\"。</p><p>然而，越来越多的业内人士开始发声支持三位女演员。一位曾与该导演共事的编剧表示：\"这些事情在圈内根本不是秘密，只是从来没有人敢站出来说。\"</p>`,
    category: "yingshi-quan",
    categoryName: "影视圈",
    imageUrl: "https://readdy.ai/api/search-image?query=three%20women%20silhouettes%20standing%20together%20in%20solidarity%2C%20dramatic%20backlighting%2C%20film%20set%20background%20out%20of%20focus%2C%20powerful%20emotional%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20tones&width=800&height=500&seq=article-7-2026&orientation=landscape",
    date: "2026-08-03",
    author: "女性权益观察",
    views: 310000,
    tags: ["性骚扰", "知名导演", "联合举报", "女演员"],
    isHot: true,
  },
  {
    id: 8,
    title: "某说唱歌手被曝私下搞电信诈骗，团队核心成员已被警方带走",
    excerpt: "令人震惊的爆料：某近期走红的说唱歌手，其真实身份竟然是一个电信诈骗团伙的核心成员。目前其团队的数名成员已被警方控制，案件正在进一步调查中。",
    content: `<p>一起令人瞠目结舌的案件近日浮出水面。某近期因一首网络神曲走红的年轻说唱歌手，被曝出其\"主业\"竟然是电信诈骗。据警方通报，该歌手是一个横跨多省的电信诈骗团伙的核心成员。</p><p>警方经过长达半年的侦查，于近日展开收网行动，已将该团伙的七名核心成员抓获归案。据了解，该团伙主要通过冒充公检法工作人员、网络贷款诈骗等手段实施犯罪，涉案金额高达数千万元。</p><p>该歌手的粉丝们对此感到难以置信。多位粉丝表示，该歌手在社交媒体上一直塑造\"努力追梦\"的励志形象，经常发布在录音棚熬夜创作的动态。讽刺的是，这些\"录音棚\"照片中的设备，实际上是用诈骗所得购买的。</p><p>目前该歌手正在被警方追捕中，据悉可能已经潜逃至境外。其经纪公司已紧急与其切割，删除了所有社交平台上的合作内容。</p>`,
    category: "yinle-quan",
    categoryName: "音乐圈",
    imageUrl: "https://readdy.ai/api/search-image?query=dark%20recording%20studio%20with%20police%20tape%20across%20the%20door%2C%20microphone%20stand%20in%20foreground%2C%20crime%20scene%20atmosphere%2C%20dramatic%20lighting%20with%20red%20and%20blue%20police%20lights%20reflection%2C%20tense%20moody%20composition&width=800&height=500&seq=article-8-2026&orientation=landscape",
    date: "2026-08-03",
    author: "社会观察员",
    views: 420000,
    tags: ["说唱歌手", "电信诈骗", "警方行动", "犯罪团伙"],
    isHot: true,
  },
  {
    id: 9,
    title: "八卦速递：某影帝被拍与女助理同游海外，妻子社交平台发意味深长动态",
    excerpt: "某实力派影帝近日被网友拍到与年轻女助理在马尔代夫度假，两人在沙滩上有亲密互动。其妻子随后在社交平台发布了一条意味深长的动态，引发网友疯狂解读。",
    content: `<p>一条来自马尔代夫的网友爆料正在网络上引发热议。一位在马代度假的中国游客拍到了某知名影帝与一名年轻女子在海滩上亲密互动的画面，并将照片发到了社交平台上。</p><p>据拍摄者描述，两人在沙滩上牵手散步，举止亲密，完全不像是工作关系。经网友比对确认，该女子正是该影帝去年新换的私人助理，年仅26岁。</p><p>更引人遐想的是，该影帝的妻子——同为演员的她，在丈夫\"工作行程\"曝光的同一天，在社交平台发布了一条动态：\"有些真相，不是不知道，只是不想说。退一步不是懦弱，而是不屑。\"配图是一杯喝了一半的红酒和一本翻开的书。</p><p>这条动态在短短几小时内获得了数十万点赞和评论。虽然该动态目前已被删除，但截图已在各大平台疯传。截至目前，影帝团队和其妻子方面均未对此事做出回应。</p>`,
    category: "lianqing-gua",
    categoryName: "恋情瓜",
    imageUrl: "https://readdy.ai/api/search-image?query=tropical%20beach%20at%20sunset%20with%20two%20distant%20figures%20walking%20along%20shoreline%2C%20paparazzi%20long%20lens%20style%2C%20Maldives%20luxury%20resort%20atmosphere%2C%20warm%20golden%20sunset%20light%2C%20romantic%20yet%20secretive%20mood&width=800&height=500&seq=article-9-2026&orientation=landscape",
    date: "2026-08-02",
    author: "八卦小能手",
    views: 189000,
    tags: ["影帝", "女助理", "海外度假", "婚变疑云"],
    isHot: false,
  },
  {
    id: 10,
    title: "最新内幕：某头部主播直播间带货数据造假，品牌方联合维权",
    excerpt: "多家品牌方向本平台透露，某直播平台头部主播的带货数据存在严重造假行为。实际退货率高达70%以上，品牌方已联合委托律师准备起诉。",
    content: `<p>一场针对直播带货数据造假的维权行动正在悄然展开。据多家品牌方联合向本平台透露，某直播平台的头部带货主播存在系统性的数据造假行为，给品牌方造成了巨大经济损失。</p><p>根据品牌方提供的数据，该主播在直播中宣称的单场销售额常达数千万元，但品牌方后台的实际成交数据显示，真实销售额仅为宣称数字的20%至30%。更严重的是，大量订单在发货前就已被取消，实际成交后的退货率也高达70%以上。</p><p>一位参与维权的品牌方代表表示：\"我们支付了高额的坑位费和佣金，换来的却是虚假的繁荣。那些漂亮的销售数字，不过是为了吸引更多品牌方入局的手段。\"</p><p>目前，已有超过十五家品牌方联合委托律师事务所，准备对该主播及其所属MCN机构提起集体诉讼。如果诉讼成功，这将是直播带货行业规模最大的一起维权案件。</p>`,
    category: "zuixin-baoliao",
    categoryName: "最新爆料",
    imageUrl: "https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20bright%20ring%20lights%20and%20products%20displayed%2C%20modern%20ecommerce%20setting%2C%20dramatic%20contrast%20between%20glamorous%20front%20and%20dark%20backstage%2C%20warm%20professional%20lighting&width=800&height=500&seq=article-10-2026&orientation=landscape",
    date: "2026-08-02",
    author: "商业调查组",
    views: 165000,
    tags: ["直播带货", "数据造假", "品牌维权", "头部主播"],
    isHot: true,
  },
  {
    id: 11,
    title: "圈内人爆料：某综艺常驻嘉宾私下人品极差，工作人员集体抵制",
    excerpt: "一位刚从某热门综艺离职的编导向本平台爆料，该节目的某常驻嘉宾私下人品极其恶劣，已有多名工作人员因无法忍受而选择离职。",
    content: `<p>一位刚从某热门综艺离职的资深编导接受了本平台的独家专访，揭露了该节目某常驻嘉宾镜头前后的巨大反差，令人唏嘘不已。</p><p>据该编导描述，这位嘉宾在镜头前永远笑容满面、亲和力十足，但在镜头关闭后立刻判若两人。他曾经因为现场空调温度不够低而把手中的水瓶砸向工作人员，也曾因为化妆师动作慢了一分钟而当众辱骂对方\"废物\"。</p><p>\"最让人心寒的是，他对底层工作人员的歧视是刻在骨子里的。\"该编导表示，这位嘉宾不允许场务和司机与他同乘一部电梯，甚至要求工作人员在他经过时必须面壁站立。</p><p>据统计，在该嘉宾参与录制的三季节目中，节目组的工作人员流失率比正常水平高出三倍。多名离职员工在离职面谈中明确表示，该嘉宾的恶劣态度是离职的主要原因之一。</p>`,
    category: "zongyi-neimu",
    categoryName: "综艺内幕",
    imageUrl: "https://readdy.ai/api/search-image?query=empty%20TV%20studio%20control%20room%20with%20monitors%20showing%20talk%20show%20set%2C%20resignation%20letter%20on%20desk%20in%20foreground%2C%20behind%20the%20scenes%20television%20production%2C%20warm%20dim%20lighting%2C%20melancholy%20atmosphere&width=800&height=500&seq=article-11-2026&orientation=landscape",
    date: "2026-08-01",
    author: "综艺观察员",
    views: 134000,
    tags: ["综艺嘉宾", "人品极差", "工作人员", "集体抵制"],
    isHot: false,
  },
  {
    id: 12,
    title: "惊爆内幕：某古装剧组被曝虐待群众演员，高温下连续拍摄致多人中暑",
    excerpt: "多名群众演员向本平台举报，某大型古装剧组在40度高温天气下，强制群众演员穿着厚重戏服连续拍摄数小时，导致多人中暑送医，剧组却试图掩盖事实。",
    content: `<p>一起令人愤怒的剧组虐待演员事件正在网络上持续发酵。多名在某大型古装剧组担任群众演员的年轻人向本平台实名举报，称该剧组在极端高温天气下对群众演员进行非人道的压榨。</p><p>据举报人描述，事发当天室外温度高达40摄氏度，地面温度更是超过了50度。然而在这样的极端天气下，剧组仍然要求近百名群众演员穿着厚重盔甲和古装长袍，在没有空调的露天场地连续拍摄了超过六个小时。</p><p>期间多名群众演员出现头晕、呕吐等中暑症状，至少有七人被救护车送往医院。但剧组方面非但没有暂停拍摄，反而要求剩余人员\"坚持一下\"。更恶劣的是，剧组试图让中暑的群众演员签署\"自愿拍摄\"的免责协议，以逃避责任。</p><p>此事曝光后，该剧的男女主演已通过工作室发表声明，表示\"对此事不知情，希望剧组妥善处理\"。但群众演员们对此表示不满：\"主演们有空调房休息，我们连口水都喝不上，他们怎么可能真的不知道？\"</p>`,
    category: "yingshi-quan",
    categoryName: "影视圈",
    imageUrl: "https://readdy.ai/api/search-image?query=film%20set%20with%20extras%20in%20ancient%20Chinese%20costumes%20under%20harsh%20sunlight%2C%20heat%20waves%20visible%2C%20exhausted%20people%20sitting%20on%20ground%2C%20dramatic%20documentary%20style%2C%20warm%20golden%20harsh%20light%2C%20social%20commentary%20photography&width=800&height=500&seq=article-12-2026&orientation=landscape",
    date: "2026-08-01",
    author: "片场观察员",
    views: 201000,
    tags: ["古装剧组", "虐待演员", "高温拍摄", "中暑"],
    isHot: true,
  },
  {
    id: 13,
    title: "某选秀明星被曝学历造假，实际仅有初中学历却自称名校毕业",
    excerpt: "粉丝们心中的\"学霸\"人设崩塌！某选秀出道的男明星被网友扒出学历造假，其自称的某211大学本科学历实际并不存在，真实学历仅为初中毕业。",
    content: `<p>又一起明星学历造假事件引发了全网热议。某选秀节目出道的当红男偶像，一直以来以\"名校学霸\"人设圈粉无数，但近日被网友扒出其学历严重造假。</p><p>据网友查证，该明星在多个场合自称毕业于某211重点大学，甚至在个人百科资料中也标注了该学历。然而有粉丝在查询该大学历届毕业生名单时，并未找到该明星的任何记录。进一步调查发现，该明星的真实学历仅为某县城的一所初中。</p><p>更令人啼笑皆非的是，该明星曾在采访中大谈自己的\"大学生活\"，描述得绘声绘色，包括\"在图书馆熬夜准备考试\"、\"和室友一起去食堂抢饭\"等细节。如今看来，这些\"回忆\"不过是精心编织的谎言。</p><p>该明星的粉丝群体出现了严重分裂。一部分粉丝认为\"学历不重要，喜欢的是他的才华\"，另一部分粉丝则感到被欺骗，要求其公开道歉。目前该明星的所有社交平台评论区均已关闭。</p>`,
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=graduation%20cap%20and%20diploma%20with%20question%20mark%20shadow%2C%20fake%20credentials%20concept%2C%20dark%20academic%20setting%20with%20bookshelves%2C%20warm%20dramatic%20lighting%2C%20mysterious%20and%20skeptical%20atmosphere&width=800&height=500&seq=article-13-2026&orientation=landscape",
    date: "2026-07-31",
    author: "学历打假人",
    views: 257000,
    tags: ["学历造假", "选秀明星", "学霸人设", "初中毕业"],
    isHot: true,
  },
  {
    id: 14,
    title: "娱乐圈最新瓜：某夫妻档综艺嘉宾被曝各玩各的，开放式婚姻内幕",
    excerpt: "一对在综艺中以\"恩爱夫妻\"形象示人的明星夫妇，被圈内人爆料实际上早已是各玩各的开放式婚姻。两人在节目上的甜蜜互动全是按剧本表演。",
    content: `<p>娱乐圈又一对\"模范夫妻\"的人设正在崩塌。据多位圈内人士爆料，那对在某夫妻档综艺中频频撒糖的明星夫妇，真实婚姻状况与镜头前截然不同。</p><p>据知情人透露，两人实际上在两年前就已经感情破裂，但考虑到共同的商业利益和两个孩子的成长，选择了维持\"开放式婚姻\"——即法律上保持婚姻关系，但私下各过各的生活，互不干涉对方的感情生活。</p><p>一位经常与这对夫妇合作的摄影师透露，在综艺节目中看到的那些\"甜蜜互动\"——牵手、拥抱、深情对视——全部都是按照节目组提供的详细剧本执行的。\"有一次拍完一个深情对视的镜头，导演喊卡的瞬间，两人的表情立刻从甜蜜变成了冷漠，那种反差让人不寒而栗。\"</p><p>此消息一出，这对夫妇的粉丝群陷入了混乱。许多曾经被他们在节目中的\"真爱\"感动过的观众表示\"感觉自己被当成了傻子\"。该综艺节目的口碑也因此受到了严重影响。</p>`,
    category: "lianqing-gua",
    categoryName: "恋情瓜",
    imageUrl: "https://readdy.ai/api/search-image?query=celebrity%20couple%20on%20TV%20show%20set%20looking%20in%20opposite%20directions%20after%20filming%2C%20reality%20TV%20production%20equipment%20around%2C%20emotional%20distance%20between%20them%2C%20warm%20studio%20lighting%2C%20cinematic%20documentary%20style&width=800&height=500&seq=article-14-2026&orientation=landscape",
    date: "2026-07-31",
    author: "情感观察室",
    views: 178000,
    tags: ["夫妻档综艺", "开放式婚姻", "各玩各的", "剧本表演"],
    isHot: false,
  },
  {
    id: 15,
    title: "重磅：某知名经纪公司被曝强制艺人签订十年长约，违约金高达天文数字",
    excerpt: "一份泄露的内部合同显示，某头部经纪公司要求旗下新人签订长达十年的\"卖身契\"，违约金设置得极为不合理。多位法律专家表示该合同可能涉及违法条款。",
    content: `<p>一份来自某头部娱乐经纪公司的内部合同近日被泄露至网络，其苛刻条款引发了法律界和娱乐圈的广泛关注。</p><p>根据泄露的合同内容，该公司要求旗下新签约艺人签订长达十年的独家经纪约，且合同期间艺人所有收入的分成比例为公司70%、艺人30%。更令人震惊的是，如果艺人想要提前解约，需要支付的违约金高达\"合同剩余年限预估收入的三倍\"，按此计算可能超过数亿元。</p><p>多位劳动法和合同法专家在看过合同后表示，该合同中的多项条款可能违反《劳动合同法》的相关规定。一位知名律师在接受采访时指出：\"十年的合约期限已经远远超出了合理范围，这种利用优势地位逼迫艺人签订不平等合同的行为，在法律上是存在严重问题的。\"</p><p>该经纪公司目前尚未对此事做出回应。但有业内人士透露，这种\"卖身契\"式的合同在娱乐圈并非个例，很多怀揣明星梦的年轻人在签约时根本不懂法律，等明白过来时已经深陷其中。</p>`,
    category: "mingxing-heiliao",
    categoryName: "明星黑料",
    imageUrl: "https://readdy.ai/api/search-image?query=legal%20contract%20document%20with%20dramatic%20red%20stamp%20and%20chains%20metaphor%2C%20dark%20corporate%20office%20setting%2C%20unfair%20agreement%20concept%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20tense%20negotiation%20atmosphere&width=800&height=500&seq=article-15-2026&orientation=landscape",
    date: "2026-07-30",
    author: "法律观察员",
    views: 293000,
    tags: ["经纪公司", "十年长约", "违约金", "不平等合同"],
    isHot: true,
  },
];